var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33397",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33397)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#043CAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1918 3.42097L11.9999 3.20006L12.8081 3.42097L12.5714 2.66672L12.8081 1.91248L11.9999 2.13339L11.1918 1.91248L11.4285 2.66672L11.1918 3.42097ZM11.1918 14.0876L11.9999 13.8667L12.8081 14.0876L12.5714 13.3334L12.8081 12.5792L11.9999 12.8001L11.1918 12.5792L11.4285 13.3334L11.1918 14.0876ZM17.7142 8.5334L16.9061 8.75431L17.1428 8.00007L16.9061 7.24582L17.7142 7.46673L18.5224 7.24582L18.2857 8.00007L18.5224 8.75431L17.7142 8.5334ZM5.47754 8.75431L6.28566 8.5334L7.09378 8.75431L6.85709 8.00007L7.09378 7.24582L6.28566 7.46673L5.47754 7.24582L5.71423 8.00007L5.47754 8.75431ZM16.9487 5.86673L16.1405 6.08765L16.3772 5.3334L16.1405 4.57915L16.9487 4.80007L17.7568 4.57915L17.5201 5.3334L17.7568 6.08765L16.9487 5.86673ZM6.24311 11.421L7.05123 11.2001L7.85935 11.421L7.62266 10.6667L7.85935 9.91248L7.05123 10.1334L6.24311 9.91248L6.4798 10.6667L6.24311 11.421ZM14.8571 3.91459L14.049 4.1355L14.2857 3.38125L14.049 2.62701L14.8571 2.84792L15.6652 2.62701L15.4285 3.38125L15.6652 4.1355L14.8571 3.91459ZM8.33468 13.3731L9.1428 13.1522L9.95093 13.3731L9.71423 12.6189L9.95093 11.8646L9.1428 12.0855L8.33468 11.8646L8.57138 12.6189L8.33468 13.3731ZM16.9487 11.2001L16.1405 11.421L16.3772 10.6667L16.1405 9.91248L16.9487 10.1334L17.7568 9.91248L17.5201 10.6667L17.7568 11.421L16.9487 11.2001ZM6.24311 6.08765L7.05123 5.86673L7.85935 6.08765L7.62266 5.3334L7.85935 4.57915L7.05123 4.80007L6.24311 4.57915L6.4798 5.3334L6.24311 6.08765ZM14.8571 13.1522L14.049 13.3731L14.2857 12.6189L14.049 11.8646L14.8571 12.0855L15.6652 11.8646L15.4285 12.6189L15.6652 13.3731L14.8571 13.1522ZM8.33468 4.1355L9.1428 3.91459L9.95093 4.1355L9.71423 3.38125L9.95093 2.62701L9.1428 2.84792L8.33468 2.62701L8.57138 3.38125L8.33468 4.1355Z",
    fill: "#FFD429"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/EU.ae49a41d87a906f00ebaa1c4d5afd0ea.svg";
export { ForwardRef as ReactComponent };